import React from "react";
import ModalPopup from "./Modal";
import deleteGif from "../../assets/gifs/delete.gif";
import DeleteSuccessModal from "./DeleteSuccessModal";

const DeleteModal = ({
  modalOpenDelete,
  setmodalOpenDelete,
  modalOpenDeleteSuccess,
  setModalOpenDeleteSuccess,
  handleDelete,
  selectedId,
  setSelectedId,
  title,
  message,
  module,
  redirectPage,
  redirectUrl

}) => {
  console.log(selectedId, "selectedId-------")
  const closeModal = () => {
    setmodalOpenDelete(false);
    setSelectedId(null);
  };

  const confirmDelete = () => {
    if (selectedId) {
      handleDelete(selectedId);
    }
    closeModal();
    setModalOpenDeleteSuccess(true);
  };

  return (
    <>
      <ModalPopup
        className="alert-box-popup"
        show={modalOpenDelete}
        size="md"
        onHide={closeModal}
        onExited={() => setSelectedId(null)}
      >
        <div className="text-center flex justify-center flex-col items-center gap-3 px-3">
          <h3>{title || "Delete Item"}</h3>
          <img src={deleteGif} className="w-[120px]" alt="del" />
          <p className="text-card-body">
            {message || "Are you sure you want to delete this item?"}
          </p>
          <div className="w-full flex justify-between gap-3 mb-2">
            <button
              className="button-field-secondary"
              onClick={confirmDelete}
            >
              Yes, Delete
            </button>
            <button className="button-field-primary" onClick={closeModal}>
              Cancel
            </button>
          </div>
        </div>
      </ModalPopup>

      <DeleteSuccessModal
        module={module}
        redirectPage={redirectPage}
        redirectUrl={redirectUrl}
        show={modalOpenDeleteSuccess}
        onClose={() => setModalOpenDeleteSuccess(false)}
      />
    </>
  );
};


export default DeleteModal;
